import Api from "../..";
import TransmedFormSubsection, {
  TransmedFormSubsectionInput,
} from "../../../dtos/transmed/process/form/subsection";
import transform from "../../../service/transform";

export default class TransmedFormSubsectionApi extends Api {
  constructor() {
    super("transmed/form/subsection");
  }

  public async post(data: TransmedFormSubsectionInput): Promise<TransmedFormSubsection> {
    return await transform(TransmedFormSubsection)((await super.post(data)).data);
  }

  public async put(
    id: string,
    data: TransmedFormSubsectionInput
  ): Promise<TransmedFormSubsection> {
    return await transform(TransmedFormSubsection)((await super.put(id, data)).data);
  }

  public async delete(id: string): Promise<void> {
    await super.delete(id);
  }
}
